import CtaButton from '@/atoms/Buttons/CTA/CtaButton';
import SubmitButton from '@/atoms/Buttons/Submit/SubmitButton';
import Textarea from '@/atoms/Textarea/Textarea';
import FileUploader from '@/molecules/FileUploader/FileUploader';
import Notification from '@/molecules/Notification/Notification';
import Textfield from '@/molecules/Textfield/Textfield';
import {useGlobalModal} from '@/organisms/Modal/ModalContext';
import constantsFactory from '@/utils/constants';
import axios from 'axios';
import {useState} from 'react';
import {confirmationMsg, errorMsg} from './content';
import {StyledConfirmationMsg, StyledContactArtistModal} from './styles';
import {ContactArtistModalProps} from './typings';

const ATTACHMENT_FIELD_NAME = 'attachment';
const {API} = constantsFactory();

const ContactArtistModal = ({artistName, artistUsername, subject}: ContactArtistModalProps) => {
  const {closeModal} = useGlobalModal();
  const [notification, setNotification] = useState<string | null>(null);
  const [loading, setLoading] = useState(false);
  const [attachmentFiles, setAttachmentFiles] = useState<File[]>([]);
  const [showConfirmation, setShowConfirmation] = useState(false);

  const onSubmit = async (formEvent: React.FormEvent<HTMLFormElement>) => {
    formEvent.preventDefault();

    setLoading(true);
    setNotification(null);
    const formData = new FormData(formEvent.currentTarget);
    formData.delete(ATTACHMENT_FIELD_NAME);

    attachmentFiles.forEach((file) => {
      formData.append(ATTACHMENT_FIELD_NAME, file);
    });

    try {
      await axios.post(`${process.env.HOST}${API.CONTACT_ARTIST}`, formData, {
        headers: {Accept: 'application/json', 'X-Requested-With': 'XMLHttpRequest'},
        withCredentials: true,
        timeout: API.TIMEOUT,
      });
      setShowConfirmation(true);
    } catch (e) {
      const errorMessage = e?.response?.data?.errors?.['__all__']?.[0] || errorMsg;
      setNotification(errorMessage);
    } finally {
      setLoading(false);
    }
  };

  return (
    <StyledContactArtistModal onClose={closeModal}>
      {showConfirmation ? (
        <StyledConfirmationMsg>
          <p>{confirmationMsg.title}</p>

          <p>{confirmationMsg.msg}</p>

          <CtaButton onClick={closeModal} maxWidth="100%">
            Ok
          </CtaButton>
        </StyledConfirmationMsg>
      ) : (
        <>
          <h5>{`Contact ${artistName}`}</h5>

          <form onSubmit={onSubmit}>
            <fieldset>
              <Textfield type="hidden" name="recipients" value={artistUsername} />

              <Textfield
                label="Subject"
                id="contact-artist-subject"
                name="subject"
                required={true}
                value={subject ?? undefined}
                disabled={!!subject}
              />

              <Textarea
                label="Your message"
                id="contact-artist-message"
                name="body"
                height={100}
                required={true}
              />

              <FileUploader
                id="contact-artist-uploader"
                name={ATTACHMENT_FIELD_NAME}
                onFilesChange={setAttachmentFiles}
              />

              {notification && <Notification message={notification} type="error" />}

              <SubmitButton maxWidth="100%" disabled={loading}>
                Send
              </SubmitButton>
            </fieldset>
          </form>
        </>
      )}
    </StyledContactArtistModal>
  );
};

export default ContactArtistModal;
